import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export class CateringOrderPolicy extends ODataSelect
{
    OrderPolicy_Id = '';
    OrderPolicy_Ref = '';
    Description = '';
    AdvanceNotice = '';
    PreparationTime_Mins = 0;
    Kitchen_OperatingHours_Start = '';
    Kitchen_OperatingHours_Stop = '';
    Name = '';
    ConcurrencyStamp = '';
    OwnedByUserId = '';
    OwnedByRoleId = '';
    CreatedByUserId = '';
    ModifiedByUserId = '';
    TenancyId = '';
    Node_Id = 0;
}